/*
POPULATION-SEARCH
Search in the population page
*/

import SearchBar from "@/components/search-bar"
import { useAppDispatch, useAppSelector } from "@/core/root-reducer"
import { STATUS_SEARCHING } from "@/redux/_status.types"
import { useState, useCallback } from "react"
import populationStore from "../model/population.store"

export default function PopulationsSearch() {
  const dispatch = useAppDispatch()
  const search = useAppSelector(populationStore.selectors.search)

  // Local state for SearchBar’s spinner animation
  const [isSearching, setIsSearching] = useState(false)

  const onSearch = useCallback(
    (value: string | null) => {
      const searchValue = value?.trim() ? value.trim() : null

      dispatch(
        populationStore.actions.search({
          value: searchValue,
          columns: ["name"]
        })
      )

      setIsSearching(false)
    },
    [dispatch]
  )

  return (
    <div className="flex-1 min-w-0">
      <SearchBar
        width="100%"
        searchText={search.value || undefined}
        onSearch={onSearch}
        status={isSearching ? STATUS_SEARCHING : undefined}
        onSearchStart={() => setIsSearching(true)}
      />
    </div>
  )
}
